// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__bfife","open":"Chat_open__L0Uy8","container":"Chat_container__x4T-U"};